import { Fragment } from "react";

import useNTGroupAthletesManualInvite from "./UseNTGroupAthletesManualInvite";

import NTGroupAthletesGrid from "../components/grids/athletesForm/NTGroupAthletesFormGrid";
import NTGroupMemberIdForm from "../components/forms/memberId/NTGroupMemberIdForm";
import NTGroupsLoadingModal from "../components/dialogs/loading/NTGroupsLoadingModal";
import NTGroupMemberDeleteModal from "../components/dialogs/memberDelete/NTGroupMemberDeleteModal";
import NTGroupInviteAthleteModal from "../components/dialogs/inviteAthlete/NTGroupInviteAthleteModal";
import NTGroupMemberDupModal from "../components/dialogs/memberDup/NTGroupMemberDupModal";

import Headings from "@usas/ui-web/components/headings/Headings";

const NTGroupAthletesManualInvite = () => {
  const {
    isGridLoading,
    gridData,
    state,
    onCloseAddPopup,
    onCloseDupPopup,
    onCloseDeletePopup,
    onSubmitMemberIdForm,
    onSubmitMembersFormGrid,
    onEditGroupAthleteClicked,
    onDeleteGroupMemberClicked
  } = useNTGroupAthletesManualInvite();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Athletes</Headings.H3>
        </div>
      </div>
      {state.displayAddPopup !== true && state.displayDupPopup !== true &&
        <NTGroupMemberIdForm primaryButtonText="Add Athlete" onSubmitFormCallback={onSubmitMemberIdForm} />
      }
      <NTGroupAthletesGrid
        gridData={gridData}
        isLoading={isGridLoading}
        onEditClicked={onEditGroupAthleteClicked}
        onDeleteClicked={onDeleteGroupMemberClicked}
        onSubmitFormCallback={onSubmitMembersFormGrid} />
      {state.displayAddPopup === true &&
        <NTGroupInviteAthleteModal memberObj={state.addGroupAthleteObj} onCloseModal={onCloseAddPopup} />
      }
      {state.displayDeletePopup === true &&
        <NTGroupMemberDeleteModal groupMemberObj={state.deleteGroupMemberObj} onCloseModal={onCloseDeletePopup} />
      }
      {state.displayDupPopup === true &&
        <NTGroupMemberDupModal groupMemberObj={state.dupGroupMemberObj} onCloseModal={onCloseDupPopup} />
      }
      <NTGroupsLoadingModal isLoading={false} />
    </Fragment>
  );
};

export default NTGroupAthletesManualInvite;